<template>
    <div>
        <div class="row mt-4">
            <div class="col-lg-6">
                <div class="card mb-4">
                    <div class="card-header text-center">{{ $t('personal_data.account_details') }}</div>
                    <div class="card-body">
                        <user-info/>
                    </div>
                </div>
                <delete-user v-if="!isMobile"/>
            </div>
            <div class="col-lg-6">
                <div class="card mb-4">
                    <div class="card-header text-center">{{ $t('personal_data.shipping_address') }}</div>
                    <div class="card-body">
                        <shipping-address/>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header text-center">{{ $t('personal_data.password') }}</div>
                    <div class="card-body">
                        <password/>
                    </div>
                </div>
                <delete-user v-if="isMobile"/>
            </div>
        </div>
    </div>
</template>

<script>
  import UserInfo from './account/profile/UserInfo.vue';
  import ShippingAddress from './account/profile/ShippingAddress.vue';
  import Password from './account/profile/Password.vue';
  import DeleteUser from './account/profile/DeleteUser.vue';

  export default {
    components: {
      UserInfo,
      ShippingAddress,
      Password,
      DeleteUser,
    },
  };
</script>
